"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Texture_1 = require("../tree/Texture");
class RectangleTexture extends Texture_1.Texture {
    constructor(stage) {
        super(stage);
        this.stage = stage;
        // For performance reasons, we skip all element and active count registration for this specific texture type.
        // This means that clipping will also not work, but that doesn't matter for rectangles anyway.
        this.becomesUsed();
    }
    _getLookupId() {
        return "__whitepix";
    }
    _getSourceLoader() {
        return (cb) => {
            const whitePixel = new Uint8Array([255, 255, 255, 255]);
            cb(undefined, { source: whitePixel, width: 1, height: 1, permanent: true });
        };
    }
    addElement(v) {
        // Ignore.
    }
    removeElement(v) {
        // Ignore.
    }
    incActiveCount() {
        // Ignore.
    }
    decActiveCount() {
        // Ignore.
    }
    isAutosizeTexture() {
        return false;
    }
}
exports.RectangleTexture = RectangleTexture;
//# sourceMappingURL=RectangleTexture.js.map